module.exports = __webpack_public_path__ + "img/蛋糕到家banner.png";